export default __webpack_public_path__ + "static/media/6.1.07b17046.jpg";